import React from "react";
import { Button, Box, Typography, Grid, Paper } from "@mui/material";
import { FaCalendar, FaMapMarkerAlt, FaPhone, FaRegEnvelopeOpen, FaRegCommentDots } from "react-icons/fa";

const DigitalInvitation = () => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" p={4}>
      <Typography variant="h4" fontWeight="bold" textAlign="center" gutterBottom>
        5 Top Features in Digital Invitation Card
      </Typography>
      
      <Grid container spacing={4} alignItems="center" justifyContent="center" maxWidth="lg">
        {/* Phone Mockup */}
        <Grid item xs={12} md={4} display="flex" justifyContent="center">
          <img src="/assets/mockup3.png" alt="Digital Invitation" style={{ width: "100%", borderRadius: "10px" }} />
        </Grid>
        
        {/* Features List */}
        <Grid item xs={12} md={6} display="flex" justifyContent="center">
          <Box display="flex" flexDirection="column" gap={2} color="text.secondary" maxWidth="400px" alignItems={{ xs: "center", md: "flex-start" }} textAlign={{ xs: "center", md: "left" }}>
            <FeatureItem icon={<FaRegEnvelopeOpen />} text="Guests can easily RSVP to confirm their attendance." />
            <FeatureItem icon={<FaPhone />} text="Contact the host via phone or WhatsApp with just one click." />
            <FeatureItem icon={<FaMapMarkerAlt />} text="Get directions to the venue using Google Maps or Waze." />
            <FeatureItem icon={<FaCalendar />} text="Save the event date as a reminder in your calendar app." />
            <FeatureItem icon={<FaRegCommentDots />} text="A special guestbook section for guests to leave their wishes." />
          </Box>
        </Grid>
      </Grid>
      
      {/* Buttons */}
      <Box mt={4} display="flex" gap={2} flexDirection={{ xs: "column", sm: "row" }} alignItems="center">
        <Button variant="contained" color="primary" fullWidth={{ xs: true, sm: false }}>Get Yours Now!</Button>
        <Button variant="contained" color="secondary" fullWidth={{ xs: true, sm: false }}>Pricing</Button>
      </Box>
    </Box>
  );
};

const FeatureItem = ({ icon, text }) => (
  <Box display="flex" alignItems="center" gap={2} textAlign={{ xs: "center", md: "left" }}>
    <Box fontSize="1.5rem" color="black">{icon}</Box>
    <Typography variant="body1">{text}</Typography>
  </Box>
);

export default DigitalInvitation;